<template>
  <div class="c-app flex-row align-items-center amsys-header">
    <CWrapper>
      <CHeader fixed with-subheader light style="position: fixed;">
        <CToggler
          in-header
          class="ml-3 d-lg-none"
          @click="$store.commit('toggleSidebarMobile')"
        />
        <CToggler
          in-header
          class="ml-3 d-md-down-none"
          @click="$store.commit('toggleSidebarDesktop')"
        />
        <CHeaderBrand class="d-lg-none">
          <h3>
            <b> <font color="Green">BUDGET</font></b>
          </h3>
        </CHeaderBrand>
        <CHeaderNav class="d-md-down-none mr-auto">
          <CHeaderNavItem class="px-3">
            <h3>
              <b> <font color="Green">BUDGET</font></b>
            </h3>
          </CHeaderNavItem>
        </CHeaderNav>
      </CHeader>
      <div class="c-body">
        <main class="c-main">
          <CRow>
            <CCol class="amsys-budget-col">
              <select
                class="form-control amsys-budget-param"
                @change="reloadData()"
                v-model="selectedData"
              >
                <option value="" disabled selected="selected">
                  Select Company
                </option>
                <option
                  v-for="item in companyResult"
                  :value="item.Oid"
                  :key="item.Oid"
                >
                  {{ item.Company }}
                </option>
              </select>
            </CCol>
            <br /><br /><br />
          </CRow>
          <CRow>
            <CCol class="amsys-budget-col">
              <select
                class="form-control amsys-budget-param"
                @change="reloadData()"
                v-model="selectedMonth"
              >
                <option value="0" selected="selected">
                  ALL
                </option>
                <option value="1">
                  JAN
                </option>
                <option value="2">
                  FEB
                </option>
                <option value="3">
                  MAR
                </option>
                <option value="4">
                  APR
                </option>
                <option value="5">
                  MEI
                </option>
                <option value="6">
                  JUN
                </option>
                <option value="7">
                  JUL
                </option>
                <option value="8">
                  AUG
                </option>
                <option value="9">
                  SEP
                </option>
                <option value="10">
                  OCT
                </option>
                <option value="11">
                  NOV
                </option>
                <option value="12">
                  DEC
                </option>
              </select>
            </CCol>
            <br /><br /><br />
            <CCol class="amsys-budget-col">
              <select
                class="form-control amsys-budget-param"
                @change="reloadData()"
                v-model="selectedYear"
              >
                <option
                  v-for="year in years()"
                  v-if="year >= 2015"
                  :value="year"
                  >{{ year }}</option
                >
              </select>
            </CCol>
          </CRow>
          <CRow v-for="item in result" v-bind:key="item.DepartmentName">
            <CCol sm="6" class="amsys-budget-cCol">
              <transition name="fade">
                <CCard v-if="show" class="amsys-det-app-card">
                  <CCardHeader class="amsys-budget-cHeader">
                    <b>
                      {{ item.DepartmentName }}
                    </b>
                    <div class="card-header-actions">
                      <CLink
                        class="card-header-action btn-minimize"
                        @click="item.visible = !item.visible"
                      >
                        <CIcon
                          :name="
                            `cil-chevron-${item.visible ? 'bottom' : 'top'}`
                          "
                        />
                      </CLink>
                    </div>
                  </CCardHeader>
                  <CCollapse :show="item.visible" :duration="400">
                    <CCardBody class="amsys-budget-cCardBody">
                      <div
                        v-for="detail in item.Details"
                        style="padding-bottom: 12px;"
                      >
                        <table
                          @click="
                            handleClick(
                              detail.BudgetAccountID,
                              detail.CompanyID,
                              detail.Month,
                              detail.Year
                            )
                          "
                        >
                          <tr>
                            <td class="amsys-budget-td" colspan="2">
                              <b>
                                <font style="font-size:13px;">{{
                                  detail.BudgetName
                                }}</font>
                              </b>
                            </td>
                          </tr>
                          <tr>
                            <td class="amsys-budget-td" colspan="2">
                              <CProgress
                                v-if="detail.Percentage <= 70"
                                :value="detail.Percentage"
                                :max="100"
                                color="gradient-success"
                                show-percentage
                                animated
                              ></CProgress>
                              <CProgress
                                v-if="
                                  detail.Percentage > 71 &&
                                    detail.Percentage <= 89
                                "
                                :value="detail.Percentage"
                                :max="100"
                                color="gradient-warning"
                                show-percentage
                                animated
                              ></CProgress>
                              <CProgress
                                v-if="
                                  detail.Percentage >= 90 &&
                                    detail.Percentage <= 100
                                "
                                :value="detail.Percentage"
                                :max="100"
                                color="gradient-almost-danger"
                                show-percentage
                                animated
                              ></CProgress>
                              <CProgress
                                v-if="detail.Percentage > 100"
                                :value="detail.Percentage"
                                :max="100"
                                color="gradient-danger"
                                show-percentage
                                animated
                              ></CProgress>
                            </td>
                          </tr>
                          <tr>
                            <td class="amsys-budget-td" width="50%">
                              <b>
                                <font style="font-size:10px;"
                                  >Rp.
                                  {{
                                    parseFloat(detail.Amount)
                                      .toFixed(2)
                                      .toString()
                                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                                  }}</font
                                >
                              </b>
                            </td>
                            <td class="amsys-budget-td" width="50%">
                              <b>
                                <font style="font-size:10px; color:#8f8f8f;"
                                  >Rp.
                                  {{
                                    parseFloat(detail.Usage)
                                      .toFixed(2)
                                      .toString()
                                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                                  }}
                                  Used</font
                                >
                              </b>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </CCardBody>
                  </CCollapse>
                </CCard>
              </transition>
            </CCol>
          </CRow>
        </main>
      </div>
      <CRow class="justify-content-center">
        <CAlert color="primary" v-if="notif" id="notifError"> </CAlert>
      </CRow>
      <CRow class="justify-content-center">
        <div
          id="loading-contentx"
          v-if="loading"
          style="margin-bottom: 20%;"
        ></div>
      </CRow>
    </CWrapper>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import "@babel/polyfill";
import VueCordova from "vue-cordova";
import CryptoJS from "crypto-js";
Vue.use(VueCordova);

export default {
  name: "Budget",
  components: {},
  data() {
    return {
      result: [],
      companyResult: [],
      listData: [],

      selectedData: "",
      selectedYear: new Date().getFullYear(),
      selectedMonth: new Date().getMonth() + 1,
      modalNote: false,
      modalOverBudget: false,
      show_input: false,
      show: false,
      showNotFound: true,
      notif: false,
      notifError: "",
      id: "",
      number: "",
      loading: false,
      isCollapsed: true,
      OverBudget: 0,
      oid: "",
      BudgetExcessReason: "",
      Notes: "",
      BudgetAccount: "",

      urlServer: "",
    };
  },
  methods: {
    years() {
      const year = new Date().getFullYear();
      return Array.from(
        { length: year - 1900 },
        (value, index) => 1901 + index
      );
    },
    handleClick(BudgetAccountID, CompanyID, Month, Year) {
      this.$router.push({
        path: "BudgetDetail",
        query: {
          BudgetAccountID: BudgetAccountID,
          CompanyID: CompanyID,
          Month: Month,
          Year: Year,
        },
      });
    },
    reloadData() {
      let data = localStorage.token;
      const formData = new FormData();
      formData.append("CompanyID", this.selectedData);
      formData.append("Month", this.selectedMonth);
      formData.append("Year", this.selectedYear);
      let sendData = JSON.stringify(Object.fromEntries(formData));
      if (this.selectedData != "undefined") {
        axios
          .post(
            `${this.urlServer}/Api/Budget/BudgetMonitoringTransactionSummary3/`,
            sendData,
            {
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers":
                  "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
                "Content-Type": "application/json",
                Authorization: "Bearer " + data,
              },
            }
          )
          .then((res) => {
            console.log(res);
            this.result.splice(0);
            res.data.forEach((element) => {
              this.result.push({ ...element, visible: false });
            });
            this.show = true;
          })
          .catch((error) => {
            Vue.$toast.open({
              message: error,
              type: "error",
              position: "bottom",
            });
          });
      } else {
      }
      this.loading = false;
    },
  },
  beforeMount() {
    this.loading = true;
    const stringToProtect = "Amsys_2@2021";
    let url = CryptoJS.AES.decrypt(localStorage.url, stringToProtect);
    const urlS = url.toString(CryptoJS.enc.Utf8);
    this.urlServer = urlS;
    let data = localStorage.token;
    const form = new FormData();
    form.append("CompanyOid", this.selectedData);
    let sendData = JSON.stringify(Object.fromEntries(form));
    if (typeof data != "undefined") {
      axios
        .post(`${urlS}/Api/General/GetCompany/`, sendData, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          this.companyResult = res.data;
        })
        .catch((error) => {
          let err = error.toString();
          if (err.toString().match(/^.*undefined.*$/)) {
            Vue.$toast.open({
              message: "Sorry, Your token has expired!",
              type: "warning",
              position: "bottom",
            });
            this.$router.push({ path: "/logout" });
          } else {
            Vue.$toast.open({
              message: error,
              type: "error",
              position: "bottom",
            });
          }
        });
    } else {
      this.$router.push({ path: "/logout" });
    }

    if (typeof this.$route.query.CompanyID === "undefined") {
    } else {
      console.log(this.$route.query.CompanyID);
      this.selectedData = this.$route.query.CompanyID;
      this.selectedMonth = this.$route.query.Month;
      this.selectedYear = this.$route.query.Year;
      this.reloadData();
    }
    this.loading = false;
  },
};
</script>
